import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { PermissionGate } from '@/components/PermissionGate';
import { Permission } from '@/common/enums/permissions.enum';
import { ScheduledMessageForm } from '@/features/mattermost/components/ScheduledMessageForm';
import { useQueryClient } from '@tanstack/react-query';

export const Route = createFileRoute('/_authenticated/mattermost-scheduled-messages/new')({
  component: MattermostScheduledMessagesNewPage,
});

function MattermostScheduledMessagesNewPage() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const handleSuccess = () => {
    queryClient.invalidateQueries({ queryKey: ['scheduled-messages'] });
    navigate({ to: '/mattermost-scheduled-messages' });
  };

  const handleCancel = () => {
    navigate({ to: '/mattermost-scheduled-messages' });
  };

  return (
    <PermissionGate permission={Permission.MATTERMOST_SEND_MESSAGE}>
      <div className="space-y-6">
        <div className="flex items-center gap-3">
          <Button
            type="button"
            variant="ghost"
            size="icon"
            onClick={handleCancel}
            aria-label="Voltar"
          >
            <ArrowLeft className="h-4 w-4" />
          </Button>
          <div>
            <h1 className="text-3xl font-bold">Nova mensagem agendada</h1>
            <p className="text-muted-foreground mt-1">
              Configure o título, conteúdo formatado e destinatários da mensagem a ser enviada no
              Mattermost.
            </p>
          </div>
        </div>

        <ScheduledMessageForm onSuccess={handleSuccess} onCancel={handleCancel} />
      </div>
    </PermissionGate>
  );
}

